import { useMemo } from 'react';
import { ITokenSuggestion } from '../Storefront/useOpportunityTokens';
import { TokenContext } from '../../models/Storefront';
import { useGetOpportunityTokensQuery } from '../../store/endpoints/StorefrontSettingsEndpoints';

/**
 * The {{{token}}} suggestions for one catalog context, shaped for TokenAutosuggestField.
 *
 * The list comes from the API rather than being restated per screen, so it cannot drift from the
 * server-side builder that renders them. Per-question tokens are deliberately absent: those are
 * derived from a single storefront's configured questions, which only the opportunity override
 * screens have in hand — see useOpportunityTokens for that richer version.
 */
export function useTokenSuggestions(context?: TokenContext): { suggestions: ITokenSuggestion[]; loading: boolean } {
    const tokens = useGetOpportunityTokensQuery(context as TokenContext, { skip: !context });

    const suggestions = useMemo<ITokenSuggestion[]>(
        () => (tokens.data?.items ?? [])
            .filter((t) => t.key)
            .map((t) => ({ token: `{{{${t.key}}}}`, description: t.description ?? '', group: 'General' })),
        [tokens.data]);

    return { suggestions, loading: tokens.isLoading || tokens.isFetching };
}
